module.exports = __webpack_public_path__ + "static/img/20008 (3).7b4b1e2.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20008 (3).webp
// module id = 7eLq
// module chunks = 14